<template>
  <div class="bg_gray" style="overflow:hidden;">
    <Header navTitle="我的课程" navPath="/mobile/center"></Header>
      <LoadListPage v-if="centercourseList.tableData.length !== 0" :pager="centercourseList.pager" v-model:loading="centercourseList.loading" v-model:finished="centercourseList.finished" @getPager="getCenterPager">
        <ul class="course_list_common">
            <li v-for="(item, index) in centercourseList.tableData"  :key="index">
              <div class="cover" @click="goPath('/mobile/course/detail/'  + item.uuid)">
                <img :src="item.cover_image" class="image" />
                <span class="hot" v-if="item.cover_image_label && item.cover_image_label != 'null'">{{ item.cover_image_label }}</span>
                <span class="tag" v-if="item.type">{{ item.type }}</span>
              </div>
              <div class="content">
                <h4 @click="goPath('/mobile/course/detail/'  + item.uuid)">{{ item.name }}</h4>
                <div class="info">
                  课时:&#12288;{{item.chapter_num}}章{{item.video_num + item.live_num + item.face_num + item.auth_num + item.experiment_num}}节
                  <span style="color:#f51c21;" v-if="item.state == '已失效'">{{ item.state }}</span>
                  <span v-else-if="item.state !== '' && item.state != '永不过期'">{{ item.state }}</span>
                </div>
              </div>
            </li>
        </ul>
      </LoadListPage>
      <van-empty v-else description="暂无内容哦~"></van-empty>
    <Overlay :isLoad="loading" :customStyle="{top: '60px'}"></Overlay>
  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import Pagination from 'components/common/Pagination'
  import { listUserPurchasedCur, listUserFreeCur, centerCoursesList } from "api/course/course/list"
  import { GetUserState } from 'api/user/auth/login'
  import LoadListPage from "components/mobile/common/LoadListPage"
  import Overlay from 'components/mobile/common/Overlay'

  export default {
    components: {
      Header,
      LoadListPage,
      Overlay
    },
    data() {
      return {
        courseItem : [],
        freeItem : [],
        pager:{},
        tabActiveName: 'join',
        loading: true,
        centercourseList: {
          loading: true,
          tableData:[],
          pager: {
            currentPage: 1,
            pageSize: 10,
            total: 0,
          },
          finished: false,
        },

        form:{
          owner_id : ''
        },
        user:{
          user_id: null
        },
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      this.getCenterList();
  },
    methods: {
      getCenterList(){
        const that = this
        let filters = {}
        filters['offset'] = (that.centercourseList.pager.currentPage - 1) * that.centercourseList.pager.pageSize
        filters['limit'] = that.centercourseList.pager.pageSize
        centerCoursesList(filters).then(res => {
          that.centercourseList.tableData.push(...that.formatData(res.data))
          that.centercourseList.pager.total = res.total
          that.centercourseList.loading = false
          that.loading = false
          if(this.centercourseList.tableData.length >= this.centercourseList.pager.total){
            this.centercourseList.finished = true
          }
        })
      },
      formatData(data) {
        for(let i=0; i<data.length; i++){
          let item = data[i]
          item['chapter_info'] = item.cur_chapter.length + '章' + (item.live_num + item.video_num + item.auth_num + item.face_num + item.experiment_num) +'节'
        }
        return data
      },
      getOwner(){
        const that = this;
        GetUserState().then((res) => {
          if (res.id) {
            this.user.user_id = res.id
            var owner_id = this.user.user_id
            this.form.owner_id = owner_id
            that.getCenterList();
          }else {
            this.form.owner_id = 'NO-USER'
            that.getCenterList();
          }
        })
      },
      goPath(path) {
        window.open(path,'_blank')
      },
      getCenterPager(pager) { //获取分页变化后数据
        this.centercourseList.pager = pager
        this.getCenterList()
      },
    }
  }
</script>
<style lang="scss" scoped>
.van-loading{
  margin-top: 50%;
}
</style>
